import { FixedSizeList as List } from 'react-window';
import React from 'react';
import { MenuItem } from '@mui/material';
import { FormElements, Text } from '@custom-components';
import PropTypes from 'prop-types';

function MultiSearchSelectMenuItems(props) {
  const { name, value, filteredOptions, handleChange, singleSelectOnly } = props;

  const sortedOptions = [
    ...filteredOptions.filter((option) => value.includes(option.value)).sort((a, b) => a.label.localeCompare(b.label)),
    ...filteredOptions.filter((option) => !value.includes(option.value)).sort((a, b) => a.label.localeCompare(b.label))
  ];

  // eslint-disable-next-line react/no-unstable-nested-components, react/prop-types
  function Row({ index, style }) {
    const option = sortedOptions[index];
    return (
      <MenuItem
        key={`menu-item-${option?.value}`}
        style={style}
        onClick={() => {
          const event = { target: { name, value: option?.value } };
          handleChange(event);
        }}
      >
        {!singleSelectOnly && (
          <span>
            <FormElements.Checkbox checked={value.includes(option?.value)} />
          </span>
        )}
        <Text.CopyBody>{option?.label}</Text.CopyBody>
      </MenuItem>
    );
  }

  return (
    <List height={200} itemCount={sortedOptions?.length} itemSize={45}>
      {Row}
    </List>
  );
}

MultiSearchSelectMenuItems.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  filteredOptions: PropTypes.shape([]),
  singleSelectOnly: PropTypes.bool,
  handleChange: PropTypes.func
};
MultiSearchSelectMenuItems.defaultProps = {
  name: '',
  value: '',
  filteredOptions: [],
  singleSelectOnly: false,
  handleChange: () => {}
};

export default MultiSearchSelectMenuItems;
